// ─────────────────────────────────────────────
//  Pure Filter / Derived-Data Utilities
// ─────────────────────────────────────────────

export const filterCompanies = (companies, query) => {
  const q = query.toLowerCase();
  return companies?.filter(
    c =>
      c.companyName.toLowerCase().includes(q) ||
      c.businessTradeName.toLowerCase().includes(q) ||
      c.companyWebsite.toLowerCase().includes(q) ||
      c.officialEmail.toLowerCase().includes(q) ||
      c.workEmail.toLowerCase().includes(q) ||
      c.gstNo.toLowerCase().includes(q) ||
      c.industryType.toLowerCase().includes(q) ||
      c.businessTradeName.toLowerCase().includes(q)
  );
};

export const filterUsers = (users, query) => {
  const q = query?.toLowerCase();
  return users.filter(
    u =>
      u.firstName.toLowerCase().includes(q) ||
      u.lastName.toLowerCase().includes(q) ||
      u.middleName.toLowerCase().includes(q) ||
      u.email.toLowerCase().includes(q)
  );
};

export const filterWorkspaces = (workspaces, query) => {
  const q = query.toLowerCase();
  return workspaces.filter(
    w =>
      w.useCaseName.toLowerCase().includes(q) ||
      w.companyName.toLowerCase().includes(q),
  );
};

/** Returns a human-readable label for a company's feature set (used in Data Sources sidebar). */
export const getFeatureLabel = (features) => {
  const hasSQL  = features.includes('sql');
  const hasFile = features.includes('file');
  if (hasSQL && hasFile) return 'SQL & Files Connected';
  if (hasSQL)            return 'SQL Only';
  if (hasFile)           return 'Files Only';
  return 'No Data Connected';
};